/* eslint-disable implicit-arrow-linebreak */
export const API_ENDPOINTS = {
  GCP_PRODUCTION: 'https://global-channel-provider-service.care.vpsvc.com',
  GCP_STAGING: 'https://global-channel-provider-service-dev.care-staging.vpsvc.com',
  TRANSLATIONS: (locale: string) =>
    `https://chat-anywhere.care.vpsvc.com/ubik-config/translations/${locale}-translations.json`,
};
